import axios from 'axios';
const apiClient = axios.create({
  baseURL: 'https://aeritech.com/api',
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('aeritech_token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + JSON.parse(token);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { apiClient };
